import { CalloutBlock, CalloutColor, ContentBlockType } from '../../../model';

export const DEFAULT_KEY_POINT_CALLOUT_PROPS = {
  title: 'Key Point',
  color: CalloutColor.Yellow,
  icon: 'key',
  type: ContentBlockType.Callout,
  content: [],
} as const satisfies Partial<CalloutBlock>;
